"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Interaction = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = require("styled-components");
var _coreBaseProps = require("@vfuk/core-base-props");
var Styled = _interopRequireWildcard(require("./styles/Interaction.style"));
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
} /* eslint-disable complexity, sonarjs/cognitive-complexity */
/**
 * Interaction component
 * Notes:
 * - onClick for RouterLink and Link are for analytics purpose only!
 */
var Interaction = /*#__PURE__*/function (_PureComponent) {
  _inherits(Interaction, _PureComponent);
  var _super = _createSuper(Interaction);
  function Interaction() {
    var _this;
    _classCallCheck(this, Interaction);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.componentName = 'Interaction';
    return _this;
  }
  _createClass(Interaction, [{
    key: "render",
    value: function render() {
      var _this$props$theme, _this$props$theme2;
      var interactionHandlers = !this.props.disabled && {
        onClick: this.props.onClick,
        onKeyDown: this.props.onKeyDown,
        onMouseDown: this.props.onMouseDown,
        onMouseUp: this.props.onMouseUp,
        onTouchStart: this.props.onTouchStart,
        onTouchEnd: this.props.onTouchEnd
      };
      var isInteractive = !!Object.values(interactionHandlers).find(function (handlerVal) {
        return handlerVal;
      });
      var Router = (_this$props$theme = this.props.theme) === null || _this$props$theme === void 0 ? void 0 : _this$props$theme.customRouter;
      var linkRouterProps = _objectSpread(_objectSpread(_objectSpread({
        ref: this.props.domRef,
        isFullSize: this.props.fullSize,
        href: this.props.href,
        'aria-label': this.props.label,
        target: this.props.target
      }, interactionHandlers), this.props.dataAttributes), {}, {
        className: this.props.className,
        id: this.props.id,
        role: this.props.role,
        rel: this.props.rel,
        'data-selector': (0, _coreBaseProps.getDataSelector)(this.props.dataSelectorPrefix),
        'data-component-name': this.componentName
      });
      if ((_this$props$theme2 = this.props.theme) !== null && _this$props$theme2 !== void 0 && _this$props$theme2.customRouter && this.props.customRouterProps) {
        return /*#__PURE__*/_react["default"].createElement(Styled.Interaction, _extends({
          as: Router
        }, linkRouterProps, this.props.customRouterProps, {
          "data-component-name": this.props.componentName || this.componentName
        }), this.props.children);
      }
      if (this.props.href) {
        return /*#__PURE__*/_react["default"].createElement(Styled.Interaction, _extends({
          as: 'a'
        }, linkRouterProps, this.props.dataAttributes, {
          "data-component-name": this.props.componentName || this.componentName
        }), this.props.children);
      }
      if (isInteractive || this.props.disabled) {
        return /*#__PURE__*/_react["default"].createElement(Styled.Button, _extends({
          ref: this.props.domRef,
          isFullSize: this.props.fullSize,
          type: this.props.type,
          "aria-label": this.props.label,
          "aria-disabled": this.props.disabled
        }, interactionHandlers, this.props.dataAttributes, {
          className: this.props.className,
          id: this.props.id,
          role: this.props.role,
          "data-selector": (0, _coreBaseProps.getDataSelector)(this.props.dataSelectorPrefix),
          "data-component-name": this.props.componentName || this.componentName
        }), this.props.children);
      }
      return /*#__PURE__*/_react["default"].createElement(Styled.BlankInteraction, _extends({
        ref: this.props.domRef,
        isFullSize: this.props.fullSize
      }, this.props.dataAttributes, {
        className: this.props.className,
        id: this.props.id,
        "data-selector": (0, _coreBaseProps.getDataSelector)(this.props.dataSelectorPrefix),
        "data-component-name": this.props.componentName || this.componentName
      }), this.props.children);
    }
  }]);
  return Interaction;
}(_react.PureComponent);
exports.Interaction = Interaction;
Interaction.defaultProps = {
  type: 'button',
  target: '_self'
};
Interaction.displayName = "Interaction";
var _default = (0, _styledComponents.withTheme)(Interaction);
exports["default"] = _default;